export default __webpack_public_path__ + "static/media/fontawesome-webfont3e6e.c1e38fd9.svg";